import { ref, computed, onMounted } from "vue";
import Glide from "@glidejs/glide";
import { useStore } from "vuex";

let glide;

export default {
    name: "CategoryPicker",
    props: {
        categories: {
            type: Array,
            required: false,
        },
    },
    setup() {
        const store = useStore()

        const breakpointCategoryPicker = 1401;
        const viewportSize = ref(window.innerWidth);

        // saving for future, for now it will always be a slider also on desktop
        // const slider = computed(() =>
        //     viewportSize.value > breakpointCategoryPicker ? false : true,
        // );

        const getLabel = (labelKey)=> store.getters['labels/getLabel']({labelCollection: 'categoryPicker', labelKey, emptyIfMissing: true})

        const glideId = "CategoryPickerGlideId";

        const determineGlideConfig = function () {
            let glideConfig = {
                perView: 2.45,
                gap: 15,
                bound: true,
                peek: {
                    after: 0,
                    before: 0,
                },
            };

            if (viewportSize.value > 1300) {
                return {
                    ...glideConfig,
                    perView: 6.75,
                    gap: 15,
                    peek: {
                        after: 1,
                        before: 0,
                    },
                };
            }

            if (viewportSize.value > 1100) {
                return {
                    ...glideConfig,
                    perView: 6.2,
                    gap: 15,
                    peek: {
                        after: 1,
                        before: 0,
                    },
                };
            }

            if (viewportSize.value > 1024) {
                return {
                    ...glideConfig,
                    perView: 5.75,
                    gap: 15,
                    peek: {
                        after: 1,
                        before: 0,
                    },
                };
            }

            if (viewportSize.value > 960) {
                return {
                    ...glideConfig,
                    perView: 5.55,
                    gap: 15,
                    peek: {
                        after: 1,
                        before: 0,
                    },
                };
            }

            if (viewportSize.value > 800) {
                return {
                    ...glideConfig,
                    perView: 5.2,
                    gap: 15,
                    peek: {
                        after: 0,
                        before: 0,
                    },
                };
            }

            if (viewportSize.value > 550) {
                return {
                    ...glideConfig,
                    perView: 3.45,
                    gap: 15,
                    peek: {
                        after: 0,
                        before: 0,
                    },
                };
            }

            return glideConfig;
        };

        onMounted(() => {
            glide = new Glide(`#${glideId}`, determineGlideConfig());

            glide.mount();

            window.addEventListener("resize", () => {
                viewportSize.value = window.innerWidth;
                if (
                    window.innerWidth > breakpointCategoryPicker &&
                    window.innerWidth < breakpointCategoryPicker
                ) {
                } else {
                    glide.update(determineGlideConfig());
                }
            });
        });

        return {
            glideId,
            getLabel
        };
    },
};
